import React from "react";
import Reveal from "./Reveal";
import { PRODUCTS } from "../data/data";
import { useCart } from "../context/CartContext";

export function Bestsellers() {
  const { addToCart } = useCart();
  const top = PRODUCTS.slice(0, 5);

  return (
    <section aria-labelledby="bestsellers-heading" className="py-24 px-6 md:px-10">
      <div className="max-w-4xl mx-auto">
        <Reveal>
          <p className="uppercase tracking-widest text-xs mb-3" style={{ fontFamily: "'JetBrains Mono', monospace", color: "#FF8A00" }}>
            Most Loved
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 id="bestsellers-heading" style={{ fontFamily: "Fraunces, serif", color: "#F5F1EA" }} className="text-4xl md:text-5xl mb-14">
            This month's bestsellers
          </h2>
        </Reveal>

        <ol className="flex flex-col">
          {top.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.07}>
              <li
                className="flex items-center gap-5 py-5"
                style={{ borderBottom: i < top.length - 1 ? "1px solid rgba(255,255,255,0.08)" : "none" }}
              >
                <span
                  style={{ fontFamily: "Fraunces, serif", color: "rgba(255,255,255,0.18)" }}
                  className="text-4xl md:text-5xl w-14 flex-shrink-0"
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0">
                  <img
                    src={p.image}
                    alt={p.name}
                    loading="lazy"
                    className="w-full h-full"
                    style={{ objectFit: "cover" }}
                  />
                </span>
                <div className="flex-1 min-w-0">
                  <p
                    className="text-xs uppercase tracking-widest mb-1"
                    style={{ fontFamily: "'JetBrains Mono', monospace", color: "rgba(245,241,234,0.5)" }}
                  >
                    {p.brand}
                  </p>
                  <h3 style={{ fontFamily: "Fraunces, serif", color: "#F5F1EA" }} className="text-base md:text-lg truncate">
                    {p.name}
                  </h3>
                </div>
                <span
                  className="hidden sm:block text-sm flex-shrink-0"
                  style={{ fontFamily: "'JetBrains Mono', monospace", color: "#F5F1EA" }}
                >
                  ₹{p.price}
                </span>
                <button
                  onClick={() => addToCart(p)}
                  className="flex-shrink-0 text-xs uppercase tracking-widest px-4 py-2 rounded-full"
                  style={{ background: "#1E9AFF", color: "#fff" }}
                >
                  Add
                </button>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default Bestsellers;
